import jsPDF from 'jspdf';
import type { InsuranceClaim, InsurancePolicy } from '../types';

export const generateClaimPDF = (claim: InsuranceClaim, policy: InsurancePolicy) => {
  const doc = new jsPDF();
  
  doc.setFontSize(20);
  doc.text('Insurance Claim', 20, 30);
  
  doc.setFontSize(12);
  doc.text(`Claim #: ${claim.claim_number}`, 20, 50);
  doc.text(`Policy #: ${policy.policy_number}`, 20, 60);
  doc.text(`Insurance Company: ${policy.insurance_company}`, 20, 70);
  doc.text(`Claim Date: ${claim.claim_date}`, 20, 80);
  doc.text(`Treatment Date: ${claim.treatment_date}`, 20, 90);
  
  doc.text(`Diagnosis Code: ${claim.diagnosis_code}`, 20, 110);
  doc.text(`Treatment Code: ${claim.treatment_code}`, 20, 120);
  
  doc.text(`Billed Amount: $${claim.billed_amount.toFixed(2)}`, 20, 140);
  if (claim.approved_amount) {
    doc.text(`Approved Amount: $${claim.approved_amount.toFixed(2)}`, 20, 150);
  }
  if (claim.paid_amount) {
    doc.text(`Paid Amount: $${claim.paid_amount.toFixed(2)}`, 20, 160);
  }
  
  doc.text(`Status: ${claim.status}`, 20, 180);
  
  if (claim.notes) {
    doc.text(`Notes: ${claim.notes}`, 20, 200);
  }
  
  return doc;
};

export const downloadClaimPDF = (claim: InsuranceClaim, policy: InsurancePolicy) => {
  const doc = generateClaimPDF(claim, policy);
  doc.save(`Claim_${claim.claim_number}_${claim.claim_date}.pdf`);
};

export const printClaimPDF = (claim: InsuranceClaim, policy: InsurancePolicy) => {
  const doc = generateClaimPDF(claim, policy);
  doc.autoPrint();
  window.open(doc.output('bloburl'), '_blank');
};
